import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/MaintenanceArea/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/MaintenanceArea/GetActive`, payload),
    GetByID: (payload) => Repository.post(`/api/MaintenanceArea/GetByID`, payload),
    Add: (payload) => Repository.post(`/api/MaintenanceArea/Add`, payload),
    Edit: (payload) => Repository.post(`/api/MaintenanceArea/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/MaintenanceArea/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/MaintenanceArea/ChangeStatus`, payload),
}
